// Mock data for Stocks Vision Academy Landing Page

export const academyInfo = {
  name: "Stocks Vision Academy",
  phone: "9752981199",
  whatsapp: "9752981199",
  address: "3rd Floor, Plot No. 48, above KSG IAS Coaching, Behind Sargam Talkies, Near hotel Rajhans, Zone-II, MP Nagar, Bhopal, Madhya Pradesh 462011",
  city: "Bhopal",
  state: "Madhya Pradesh",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.6420!2d77.4126!3d23.2324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDEzJzU2LjYiTiA3N8KwMjQnNDUuNCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const courses = [
  {
    id: 1,
    title: "Advanced Technical Analysis",
    description: "Master the art of reading charts and making informed trading decisions",
    topics: [
      "Price Action Trading",
      "Technical Indicators (RSI, MACD, Bollinger Bands)",
      "Trend Analysis & Chart Patterns",
      "Support & Resistance Levels",
      "Risk Management & Position Sizing",
      "Trade Psychology & Discipline"
    ],
    suitable: "Beginners to Advanced"
  },
  {
    id: 2,
    title: "Options Trading Mastery",
    description: "Comprehensive options trading strategies for consistent income generation",
    topics: [
      "Index Options (NIFTY & Bank NIFTY)",
      "Stock Options Trading",
      "Option Greeks (Delta, Gamma, Theta, Vega)",
      "Option Chain Analysis",
      "Intraday Options Strategies",
      "Positional Options Strategies",
      "Hedging & Risk Management"
    ],
    suitable: "Intermediate to Advanced"
  }
];

export const problems = [
  {
    icon: "TrendingDown",
    problem: "Consistent losses despite watching countless YouTube videos",
    impact: "No structured approach, just random trades based on tips"
  },
  {
    icon: "AlertCircle",
    problem: "Unable to manage risk effectively",
    impact: "One bad trade wipes out weeks of small profits"
  },
  {
    icon: "Brain",
    problem: "Emotional trading and revenge trading",
    impact: "Making impulsive decisions based on fear and greed"
  },
  {
    icon: "Target",
    problem: "Lack of execution clarity",
    impact: "Knowing theory but unable to apply in live markets"
  }
];

export const whyChooseUs = [
  {
    icon: "LineChart",
    title: "Live Market Training",
    description: "Learn with real-time market examples, not just theory from textbooks"
  },
  {
    icon: "Shield",
    title: "Risk Management Focus",
    description: "Capital protection comes first. We teach you how to survive before you thrive"
  },
  {
    icon: "BookOpen",
    title: "Simple & Practical",
    description: "Complex concepts explained in simple Hindi/English with real chart examples"
  },
  {
    icon: "Users",
    title: "Post-Course Support",
    description: "Continued guidance even after course completion to ensure your success"
  },
  {
    icon: "Globe",
    title: "Online + Offline Classes",
    description: "Join offline at our Bhopal centre or live online from anywhere in India — same trainer, same quality"
  },
  {
    icon: "Award",
    title: "Experienced Mentorship",
    description: "Learn from active traders with real market experience, not just educators"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Working Professional",
    rating: 5,
    text: "Best decision I made for my trading journey. The practical approach and risk management techniques have transformed how I trade.",
    location: "Bhopal"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Beginner Trader",
    rating: 5,
    text: "Started with zero knowledge. The way complex concepts are explained in simple language made learning easy. Highly recommended!",
    location: "Bhopal"
  },
  {
    id: 3,
    name: "Amit Patel",
    role: "Business Owner",
    rating: 5,
    text: "Excellent course structure. The options trading module helped me understand derivatives clearly. Post-course support is a big plus.",
    location: "Bhopal"
  }
];

export const faqs = [
  {
    question: "Is Deepak Singhai NISM certified?",
    answer: "Yes. Deepak Singhai is a NISM Certified Research Analyst (RA) — certified by the National Institute of Securities Markets, which is established by SEBI, Govt. of India. This certification ensures that all education at Stocks Vision Academy follows a structured, SEBI-framework aligned approach."
  },
  {
    question: "What is the batch size at Stocks Vision Academy?",
    answer: "We intentionally keep our batch sizes small to ensure every student receives genuine personal attention from Deepak Singhai. Unlike large institutes where you are just a number, at Stocks Vision Academy you are a student who is known, guided, and supported personally."
  },
  {
    question: "Is support available after the course ends?",
    answer: "Yes. Post-course support is a core part of what we offer at Stocks Vision Academy. Deepak Singhai remains available for doubt clearing and guidance even after your batch is complete. Your learning journey does not stop when the course does."
  },
  {
    question: "Are these courses suitable for complete beginners?",
    answer: "Absolutely. Our Advanced Technical Analysis course starts from the very basics and is designed for complete beginners as well as experienced traders who want to improve. Deepak Singhai explains every concept in simple Hindi and English with real market examples — no prior knowledge required."
  },
  {
    question: "Do you provide investment tips or stock recommendations?",
    answer: "No. Stocks Vision Academy is a purely educational institute. We do not provide investment advice, trading tips, or stock recommendations. All courses are strictly for educational and skill development purposes only. We are not SEBI Registered Investment Advisors."
  },
  {
    question: "Where is Stocks Vision Academy located in Bhopal?",
    answer: "We are located at 3rd Floor, Plot No. 48, Above KSG IAS Coaching, Behind Sargam Talkies, Near Hotel Rajhans, Zone-II, MP Nagar, Bhopal — 462011. You can contact Deepak Singhai directly on 9752981199 or WhatsApp for directions or to book a free demo class."
  },
  {
    question: "How long are the courses and what is the fee?",
    answer: "Both our courses — Advanced Technical Analysis and Options Trading Mastery — run for 30 to 45 days with live market sessions included. For the latest fee details and batch schedule, please contact Deepak Singhai directly on 9752981199 or fill the enquiry form on this page."
  },
  {
    question: "Is a free demo class available before enrolling?",
    answer: "Yes! We offer a free demo class for all new enquiries so you can experience Deepak Singhai's teaching style and our classroom environment before committing. Simply fill the enquiry form or WhatsApp us on 9752981199 to book your free demo."
  }
];
